<div
  class="toast"
  [class]="'toast toast--' + toast.type"
  [class.toast--expanded]="hasBody()"
  [class.toast--leaving]="toast.isLeaving"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
  (click)="onDismiss()"
>
  <div class="toast__inner">
    <div class="toast__surface">
      <div class="toast__main">
        <div class="toast__icon">
          <div class="toast__icon-circle">
            <lucide-icon [name]="iconName()" [size]="18" />
          </div>
        </div>

        <div class="toast__content">
          <div class="toast__header">
            <span class="toast__label">{{ headerText() }}</span>

            <button
              type="button"
              class="toast__close"
              aria-label="Cerrar notificación"
              (click)="$event.stopPropagation(); onDismiss()"
            >
              ✕
            </button>
          </div>

          @if (hasBody()) {
            <div class="toast__body">
              <p class="toast__message">
                {{ toast.message }}
              </p>

              @if (toast.action) {
                <button
                  type="button"
                  class="toast__action"
                  (click)="$event.stopPropagation(); onActionClick()"
                >
                  {{ toast.action.label }}
                </button>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
